import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { format, add, parse, isValid, parseISO } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class PatternValidatorService {
  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmPasswordService {
  static MatchingPassword(control: AbstractControl) {
    const password = control.get('newPassword').value; // to get value in input tag
    const confirmPassword = control.get('reNewPassword').value; // to get value in input tag
    const currentError = control.get('reNewPassword').errors;
    const confirmControl = control.get('reNewPassword');

    if (password !== confirmPassword && confirmPassword !== '') {
      confirmControl.setErrors({ ...currentError, not_matching: true });
    } else {
      confirmControl.setErrors(currentError);
    }
  }
}

@Injectable({
  providedIn: 'root',
})
export class PeselValidatorService {
  static isValidPesel(pesel: string): boolean {
    if (pesel.length !== 11) {
      return false; // PESEL must be 11 characters long
    } else {
      let year = parseInt(pesel.substring(0, 2), 10);
      let month = parseInt(pesel.substring(2, 4), 10);
      const day = parseInt(pesel.substring(4, 6), 10);

      if (month > 20) {
        month -= 20; // For people born in 21st century we subtract 20 from month
        year += 2000;
      } else {
        year += 1900; // For people born before 2000 we add 1900 to year
      }

      const formattedDay = ('0' + day).slice(-2);
      const formattedMonth = ('0' + month).slice(-2);

      if (!isValid(parseISO(`${year}-${formattedMonth}-${formattedDay}`))) return false;

      const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
      let sum = 0;
      for (let i = 0; i < 10; i++) {
        sum += parseInt(pesel.charAt(i), 10) * weights[i];
      }
      sum = (10 - (sum % 10)) % 10;

      return parseInt(pesel.charAt(10), 10) === sum;
    }
  }

  static peselValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      const isValid = PeselValidatorService.isValidPesel(control.value);

      // if true, return no error (no error), else return error indicating invalid PESEL
      return isValid ? null : { invalidPesel: true };
    };
  }
}
